function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('./calculateCart.js'),
  calculateCart = _require.calculateCart;
var packBasket = function packBasket(basketId, elmerId, cart) {
  var calculatedCart = calculateCart(cart);
  var apporder = {
    src: null,
    orders: []
  };
  var appOrderCount = {
    val: 0,
    isOrder: false,
    useEpay: false,
    is_authorized: false,
    is_delivery: false
  };
  var authorizedPayments = [];
  return _objectSpread(_objectSpread({}, calculatedCart.basketdata), {}, {
    /*
     * we can discard tax, fee and promo priceTaxFeeAdjusters immediately
     * since they contain no state particular to this basket
     */
    priceTaxFeeAdjusters: calculatedCart.basketdata.priceTaxFeeAdjusters.filter(function (a) {
      return !['fee', 'freeproducts', 'promo', 'tax'].includes(a.name);
    }),
    apporder: apporder,
    appOrderCount: appOrderCount,
    authorizedPayments: authorizedPayments,
    basketid: basketId,
    originalElmerId: elmerId,
    total: calculatedCart.totals.total
  });
};
module.exports = packBasket;